import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { useApiQuery } from './useApiQuery';

const useGetInventoryDevices = ({ useruuid, queryParams, providerId, offset, limit }) => {
  const trans = useSelector(translator);
  const deviceApi = useSelector((state) => state.apis.deviceApi);

  const query = new URLSearchParams(queryParams).toString();

  return useApiQuery(
    ['inventoryDevices', useruuid, query, providerId, offset, limit],
    () =>
      new Promise((resolve, reject) => {
        deviceApi.getDevicesByProviderId(
          providerId,
          offset,
          limit,
          queryParams,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              resolve(data?.devices);
            },
            errorCallback: () => {
              reject([]);
            },
            failCallback: () => {
              reject([]);
            },
          })
        );
      }),
    {
      invalidateKeys: [['adminDashboardByDateTime']], // ✅ auto invalidate
    }
  );
};

export default useGetInventoryDevices;
